import React from "react";
import {
  Dropdown,
  DropdownMenu,
  DSProvider,
  IconButton,
} from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import {
  DotsVerticalOutlined,
  CopyOutlined,
  PencilOutlined,
  DeleteOutlined,
} from "@toddle-edu/ds-icons";
import EventUpdateConfirmationModal from "MyCalendar/components/EventModalV2/components/EventUpdateConfirmationModal";
import {
  deleteSchoolCalendarEvent,
  updateEventModalV2,
} from "MyCalendar/modules/MyCalendarModule";
import { connect } from "react-redux";
import useDeleteRecurrance from "../../../EventModalV2/hooks/useDeleteRecurrance";
import RecurrenceConfirmationModal from "../../../EventModalV2/components/RecurrenceConfirmationModal";
import { mapStateToProps } from "../../../EventModalV2/modules/Utils";

const ActionsDropdown = ({
  id,
  isFullDayEvent,
  onCloseEventDetailsModal,
  deleteSchoolCalendarEvent,
  onCopyEvent,
  onEditEvent,
  onDeleteEvent,
  isEventDetailsLoading,
  isCalendarEventInUserScope,
  updateEventModalV2,
  isRepeatEvent,
  eventTitle = "",
  eventModalV2,
  testId,
}) => {
  const { t } = useI18n();
  const {
    clickHandler,
    isConfirmationModalOpen,
    onCloseConfirmationModal,
    onSaveRecurrenceHandler,
    repeatEventModalActionRef,
    setIsConfirmationModalOpen,
    showNewConfirmationModal,
  } = useDeleteRecurrance({ updateEventModalV2, isRepeatEvent });

  const deleteClickHandler = () => {
    clickHandler();
  };

  const onConfirm = async data => {
    const { message, sendMessage } = data;
    try {
      await deleteSchoolCalendarEvent({
        id,
        isFullDayEvent,
        message,
        sendMessage,
        actionFor: eventModalV2?.repeatScope || "ALL",
      });
    } catch (error) {
      console.error("Error deleting event:", error);
    }
    onCloseEventDetailsModal();
    setIsConfirmationModalOpen(false);
  };

  const actionOptions = [
    {
      key: "DUPLICATE",
      label: t("common:duplicate"),
      icon: <CopyOutlined variant={"subtle"} />,
      disabled: isEventDetailsLoading || !isCalendarEventInUserScope,
      disabledTooltip: !isEventDetailsLoading
        ? t("calendar:no_access_recipient_dupliacte_disabled")
        : undefined,
    },
    {
      key: "EDIT",
      label: t("common:edit"),
      icon: <PencilOutlined variant={"subtle"} />,
      disabled: isEventDetailsLoading || !isCalendarEventInUserScope,
      disabledTooltip: !isEventDetailsLoading
        ? t("calendar:no_access_recipient_edit_disabled")
        : undefined,
    },
    {
      key: "DELETE",
      label: t("common:delete"),
      icon: <DeleteOutlined variant={"subtle"} />,
      disabled: isEventDetailsLoading || !isCalendarEventInUserScope,
      disabledTooltip: !isEventDetailsLoading
        ? t("calendar:no_access_recipient_delete_disabled")
        : undefined,
    },
  ];

  const handleDropdownItemClick = option => {
    switch (option?.key) {
      case "DUPLICATE":
        onCopyEvent();
        break;
      case "EDIT":
        onEditEvent();
        break;
      case "DELETE":
        deleteClickHandler();
        break;
      default:
        break;
    }
  };

  return (
    <DSProvider dsVersion="2.0">
      <Dropdown
        dsVersion="2.0"
        overlay={
          <DropdownMenu
            dsVersion="2.0"
            showSelection
            hasMultilineOptions
            options={actionOptions}
            onClick={handleDropdownItemClick}
            testId={`${testId}-dropdown-menu`}
          />
        }
      >
        <IconButton
          dsVersion="2.0"
          variant="neutral"
          type="plain"
          icon={<DotsVerticalOutlined />}
          testId={`${testId}-actions-dropdown`}
        />
      </Dropdown>
      <EventUpdateConfirmationModal
        isOpen={isConfirmationModalOpen}
        onConfirm={onConfirm}
        onClose={onCloseConfirmationModal}
        title="calendar:delete_event"
        checkboxLabel="calendar:notify_all_the_participants_about_the_deletion_of_this_event"
        confirmationMessage="calendar:delete_confirmation_message"
        saveButtonLabel="common:delete"
        cancelButtonLabel="common:cancel"
        height="max-content"
        showWarning={!showNewConfirmationModal}
        messagePlaceholder="calendar:add_optional_message"
        showMessageLabel={!showNewConfirmationModal}
      />
      <RecurrenceConfirmationModal
        actionRef={repeatEventModalActionRef}
        isOpen={false}
        eventTitle={eventTitle || ""}
        title={t("calendar:delete_repeat_event")}
        onSave={onSaveRecurrenceHandler}
        onClose={onCloseConfirmationModal}
      />
    </DSProvider>
  );
};

ActionsDropdown.propTypes = {};

ActionsDropdown.defaultProps = {};

const mapActionCreators = {
  deleteSchoolCalendarEvent,
  updateEventModalV2,
};

export default connect(mapStateToProps, mapActionCreators)(ActionsDropdown);
